import React, { useEffect, useState } from 'react';
import {
  Button,
  createStyles,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Theme,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Autocomplete } from '@material-ui/lab';

import { useMutation, useQuery } from 'react-query';
import MotorPlate from './motorPlate';
import Plate from './plate';
import { getTPLs } from '../requests/getTPLs';
import axios from 'axios';
import getVehicleByPlateNum from '../requests/getVehicleByPlateNum';
import getVehicles from '../requests/getVehiclesCount';
import { createEntrance } from '../requests/createVehicleEntrance';
import { addNewDriver } from '../requests/addNewDriver';
import { Redirect, useHistory } from 'react-router-dom';
import handleNotfication from '../../../utils/handleNotfication';
import getDriverByOwnerId from '../requests/getDriverByOwnerId';
import { Entrance } from 'client-sdk/src/entrances/interface';
import { Driver } from 'client-sdk/src/drivers/interface';
import { parseInt } from 'lodash';

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inlineRadioGroups: {
      display: 'flex',
      flexDirection: 'row',
    },
    drawDown: {
      padding: '20px 12px',
      backgroundColor: '#fff',
      marginBottom: '50px',
    },
    circularIcon: {
      color: '#2f4858',
      paddingLeft: '8px',
      position: 'fixed',
      bottom: 0,
      opacity: '90%',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    errorPlate: {
      marginTop: '20px',
      marginLeft: '15px',
    },
    topText: {
      color: '#2f4858',
      fontSize: '16px',
    },
    appBar: {
      padding: '16px',
      backgroundColor: '#ffffff',
      zIndex: theme.zIndex.drawer + 1,
      boxShadow: 'none',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    bottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '80px',
      backgroundColor: '#fff',
      borderTop: '0.5px solid #828282',
      padding: '16px',
      zIndex: 12,
    },
  })
);

const carTypes = [
  'پراید',
  'پژو ۴۰۵',
  'پژو ۲۰۶',
  'آریسان',
  'پیکان وانت',
  'پیکان',
  'ام وی ام',
  'پرشیا',
  'تندر ۹۰',
  'تیبا',
  'دنا',
  'ریو',
  'سمند',
  'نیسان',
  'ون دلیکا',
];

export const AddDriverOrderForm = (props: {}) => {
  const classes = useStyles();
  const { register, handleSubmit, watch, getValues, errors, setValue } =
    useForm();

  const [entityType, setEntityType] = useState('order');
  const [vehicleType, setVehicleType] = useState('CAR');
  const [platePattern, setPlatePattern] = useState<any>('');
  const [courier, setCourier] = useState<any>('');
  const [carType, setCarType] = useState<any>('نامشخص');
  const [formType, setFormType] = useState<'create' | 'fill'>('create');
  const [isColorSpecified, toggleColorSpecified] = useState<boolean>(false);
  const [driverName, setDriverName] = useState<string | undefined>(undefined);
  const [driverPhoneNum, setDriverPhoneNum] = useState<string | undefined>(
    undefined
  );
  const [hasDriverName, setHasDriverName] = useState<boolean | undefined>(
    undefined
  );
  const [hasPhoneNumber, setHasPhoneNumber] = useState<boolean | undefined>(
    undefined
  );

  const token = localStorage.getItem('token');
  const history = useHistory();

  // const addNewDriver = (driver: any) => {
  //   return axios.post(
  //     "https://api.qa.ronad.ir/api/vehicle-entrances/driver",
  //     driver,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "*/*",
  //         "Content-Type": "application/json",
  //       },
  //     },
  //   );
  // };
  //
  const driverMutation = useMutation(addNewDriver);

  const submitEntrance = useMutation(createEntrance);

  useEffect(() => {
    setPlatePattern(/^\d{2}[\u0600-\u06FF]\d{3}\-\d{2}$/g);
    if (vehicleType === 'MOTORCYCLE') {
      setPlatePattern(/^\d{8}$/g);
    }
  }, [vehicleType]);
  useEffect(() => {
    if (vehicleType !== 'MOTORCYCLE' && getValues().plateNumber.length === 9) {
      getVehicle(getValues().plateNumber);
    }
    if (vehicleType === 'MOTORCYCLE' && getValues().plateNumber.length === 8) {
      getVehicle(getValues().plateNumber);
      setCarType('موتورسیکلت');
    }
  }, [watch(['plateNumber'])]);

  // get vehicle by plateNumber
  const getVehicle = (plateNum: any) => {
    //reqVehicle => success => setFormType register - fail => setFormType create
    const response = getVehicleByPlateNum(plateNum);
    let registeredVehicleData;
    let driverInformation;
    let Courier;
    response
      .then(recoveredData => {
        registeredVehicleData = recoveredData.data;
        if (registeredVehicleData.length > 0) {
          //Request with ownerId to get driver info
          console.log("Getting data");
          const driverResponse = getDriverByOwnerId(
            registeredVehicleData[0].ownerId
          );
          console.log("After response");
          driverResponse.then((driverData: any) => {
            driverInformation = driverData.data;
            console.log(driverInformation);
            setValue('phoneNumber', parseInt(driverInformation.phoneNumber));
            setDriverPhoneNum(driverInformation.phoneNumber);
            setValue('driverName', driverInformation.name);
            setDriverName(driverInformation.name);
          });

          setValue('carColor', registeredVehicleData[0].color);
          setFormType('fill');
          setVehicleType(registeredVehicleData[0].klass);
          if (vehicleType === 'MOTORCYCLE') {
            setCarType('موتورسیکلت');
            setValue('carColor', 'موتورسیکلت');
          } else {
            setCarType(registeredVehicleData[0].type);
          }
          // console.log(registeredVehicleData[0].type);
          setValue('carType', registeredVehicleData[0].type);
          Courier = TPLs?.data.filter(element => {
            return element.id === registeredVehicleData[0].fleetId;
          })[0];
          setCourier(Courier.id);
          setValue('courier', Courier.name);
          // Courier = TPLs?.data.map(element => {
          //   console.log(element);
          // })
          // .filter((element: any, index) => {
          //   return element[index].fleetId === registeredVehicleData[0].fleetId;
          // })
        } else {
          setFormType('create');
        }
      })
      .catch(err => {
        console.log(err);
      });
    // if(response.data.length == 0){
    //     console.log("Plate doesn't exist");
    //     setFormType("create")
    //   }
    // else if (response.data.length > 0){
    //     setFormType("fill");
    //   }
  };

  const onSubmit = (data: any) => {
    if (formType === 'create') {
      const payload = {
        ...(vehicleType === 'MOTORCYCLE' && { color: 'موتورسیکت' }),
        color: data.carColor ? data.carColor : 'نامشخص',
        parkingNumber: data.parkingNumber ? data.parkingNumber : '-1',
        name: data.driverName ? data.driverName : 'ناشناس',
        plateNumber: data.plateNumber,
        vehicleClass: vehicleType ? vehicleType : 'موتورسیکلت',
        vehicleType: carType,
        fleetId: courier,
        phoneNumber: data.phoneNumber,
        type: "ORDER"
      };

      driverMutation.mutate(payload as Entrance, {
        onSuccess: (mydata, variables) => {
          //othertoast
          handleNotfication('راننده با موفقیت افزوده شد', 'success');
          history.push('/security/active-drivers');
        },

        onError: (error, variables) => {
          //error toast
          handleNotfication('خطا در افزودن راننده', 'error');
        },
      });
    } //Added mutation
    else {
      let fetchedPlateVehicleId;
      getVehicleByPlateNum(data.plateNumber).then(fetchedData => {
        fetchedPlateVehicleId = fetchedData.data[0].id;
        const payload = {
          parkingNumber: data.parkingNumber,
          vehicleId: fetchedPlateVehicleId,
          type: "ORDER"
        };

        // const myData = createEntrance(payload as Entrance);
        // console.log("data is: ", myData);

        submitEntrance.mutate(payload as Entrance, {
          onSuccess: (mydata, variables) => {
            console.log('Successful req: ', mydata);
            handleNotfication('ورود با موفقیت ثبت شد', 'success');
            history.push('/security/active-drivers');
            // return (window.location.href = '/security/active-drivers');
          },
          onError: (error, variables) => {
            handleNotfication('خطا در ثبت ورود', 'error');
          },
        });
      });

      // const fetchedPlateNumber = getVehicleByPlateNum(data.plateNumber).then(fetchedData => { return fetchedData.data.plateNumber });
      // console.log(fetchedPlateNumber);
      // const payload = {
      //   parkingNumber: data.parkingNumber,
      //   vehicleId: fetchedPlateVehicleId,
      // };
      // submitEntrance.mutate(payload);
    }

    // console.log({
    //   ...data,
    //   entityType,
    //   vehicleType,
    //   courier,
    // })
    // // based on formtype request to register driver
    // or create driver
  };

  const handleEntityRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEntityType((event.target as HTMLInputElement).value);
  };

  const handleVehicleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setVehicleType((event.target as HTMLInputElement).value);
  };

  const jumpFocusOn = (itemID: string): void => {
    const focusableElem: HTMLElement | null = document.getElementById(itemID);
    focusableElem?.focus();
  };

  const {
    isLoading,
    error,
    data: TPLs,
  } = useQuery('TPLs', getTPLs, {
    staleTime: 100 * 60 * 1000, //100 minutes fresh data
    cacheTime: 300 * 60 * 1000, //hold cached data for 300 minutes
  });

  const values = getValues();

  return (
    <div className={classes.drawDown}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item>
            <FormLabel component="legend">وسیله نقلیه</FormLabel>
            <RadioGroup
              row
              name="vehicleType"
              value={vehicleType}
              onChange={handleVehicleRadioChange}
              defaultValue="CAR"
            >
              <FormControlLabel
                value="CAR"
                control={<Radio />}
                label="سواری"
                defaultChecked={true}
              />
              {/* <FormControlLabel
                value="PICKUPS"
                control={<Radio />}
                label="وانت"
              /> */}

              <FormControlLabel
                value="MOTORCYCLE"
                control={<Radio />}
                label="موتور سیکلت"
              />
            </RadioGroup>
          </Grid>

          <Grid item xs={12}>
            {vehicleType === 'MOTORCYCLE' ? (
              <MotorPlate
                getNumber={number => setValue('plateNumber', number)}
              />
            ) : (
              <Plate getNumber={number => setValue('plateNumber', number)} />
            )}
            <TextField
              fullWidth
              style={{ display: 'none' }}
              id="plateNumber"
              name="plateNumber"
              label="پلاک خودرو"
              className={classes.textInput}
              inputRef={register({
                required: true,
                pattern: platePattern,
                minLength: vehicleType === 'MOTORCYCLE' ? 8 : 9,
                maxLength: vehicleType === 'MOTORCYCLE' ? 8 : 9,
              })}
              error={errors.plateNumber && true}
            />
            <div className={classes.errorPlate}>
              {values.plateNumber &&
                !values.plateNumber.match(platePattern) && (
                  <p className={classes.errorText}>
                    {'فرمت فیلد پلاک خودرو صحیح نیست'}
                  </p>
                )}
            </div>
            <FormHelperText error focused>
              {errors.plateNumber &&
                errors.plateNumber.type === 'required' &&
                'پلاک الزامی میباشد'}
            </FormHelperText>
          </Grid>

          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: false })}
              fullWidth
              name="phoneNumber"
              id="phone-number"
              label="شماره موبایل"
              variant="outlined"
              type="number"
              InputLabelProps={{
                shrink: !!driverPhoneNum || hasPhoneNumber,
              }}
              onChange={(event: any, newValue: any | null) => {
                // console.log("Event: ", event, "\nValue: ", newValue);
                if (newValue) {
                  setDriverPhoneNum(parseInt(newValue.id));
                } else {
                  setDriverPhoneNum(undefined);
                }
                if (event.target.value !== '') {
                  setHasPhoneNumber(true);
                }
                if (event.target.value === undefined) {
                  setHasPhoneNumber(false);
                }
              }}
            />
            <FormHelperText error focused>
              {errors.phoneNumber && 'شماره موبایل الزامی میباشد'}
            </FormHelperText>
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              id="courier"
              options={TPLs?.data?.length > 0 ? TPLs?.data : []}
              getOptionLabel={option => option.name}
              onChange={(event: any, newValue: any | null) => {
                // console.log("Event: ", event, "\nValue: ", newValue);
                if (newValue) {
                  setCourier(newValue.id);
                } else {
                  setCourier('');
                }
              }}
              onClose={() => jumpFocusOn('carType')}
              // value={courier}
              renderInput={params => (
                <TextField
                  inputRef={register({ required: true })}
                  name="courier"
                  {...params}
                  label="کوریر"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: !!courier,
                  }}
                />
              )}
            />
            <FormHelperText error focused>
              {errors.courier && 'کوریر الزامی میباشد'}
            </FormHelperText>
          </Grid>

          {vehicleType !== 'MOTORCYCLE' && (
            <>
              <Grid item xs={6}>
                <Autocomplete
                  id="carType"
                  freeSolo
                  options={carTypes}
                  getOptionLabel={option => option}
                  onChange={(event: any, newValue: any | null) => {
                    setCarType(newValue);
                  }}
                  onClose={() => jumpFocusOn('carColor')}
                  value={carType}
                  renderInput={params => (
                    <TextField
                      inputRef={register({ required: false })}
                      name="carType"
                      {...params}
                      label="مدل خودرو"
                      variant="outlined"
                    />
                  )}
                />
                <FormHelperText error focused>
                  {errors.carType && 'مدل خودرو الزامی میباشد'}
                </FormHelperText>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  id="carColor"
                  label="رنگ خودرو"
                  variant="outlined"
                  name="carColor"
                  inputRef={register({ required: false })}
                  onChange={(event: any, typedInValue: any | null) => {
                    if (typedInValue != '') {
                      toggleColorSpecified(true);
                    }
                    if (typedInValue == '') {
                      toggleColorSpecified(false);
                    }
                  }}
                  InputLabelProps={{
                    shrink: !!values.carColor || isColorSpecified,
                  }}
                />
                <FormHelperText error focused>
                  {errors.carColor && 'رنگ خودرو الزامی میباشد'}
                </FormHelperText>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <TextField
              fullWidth
              id="driver-name"
              name="driverName"
              label="نام راننده"
              variant="outlined"
              inputRef={register({ required: false })}
              InputLabelProps={{
                shrink: !!driverName || hasDriverName,
              }}
              onChange={(event: any, newValue: any | null) => {
                // console.log("Event: ", event, "\nValue: ", newValue);
                if (newValue) {
                  setDriverName(newValue.id);
                } else {
                  setDriverName('');
                }
                if (event.target.value !== '') {
                  setHasDriverName(true);
                }
                if (event.target.value === '') {
                  setHasDriverName(false);
                }
              }}
            />
            <FormHelperText error focused>
              {errors.driverName && 'نام راننده الزامی میباشد'}
            </FormHelperText>
          </Grid>

          {/* {vehicleType !== 'MOTORCYCLE' && ( */}
          {/* )} */}

          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: false })}
              fullWidth
              type="number"
              name="parkingNumber"
              id="parking-number"
              label="شماره پارکینگ"
              variant="outlined"
            />
            <FormHelperText error focused>
              {errors.parkingNumber && 'شماره پارکینگ الزامی میباشد'}
            </FormHelperText>
          </Grid>
        </Grid>
        <div className={classes.bottom}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
          >
            {formType === 'create' ? 'ذخیره راننده جدید' : 'ثبت اطلاعات'}
          </Button>
        </div>
      </form>
    </div>
  );
};
